import { createSelector } from 'reselect'

const getChild = (state) => state.child

export const getChildSetup = createSelector(
  [getChild],
  (child) => child.setup,
)
